import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  company: string;
  logoUrl?: string;
  imageUrl?: string;
}
export function TestimonialCard({
  quote,
  author,
  role,
  company,
  logoUrl,
  imageUrl
}: TestimonialCardProps) {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-md transition-shadow duration-300" data-id="element-327">
      <Quote className="w-10 h-10 text-[#7E3007]/20 mb-6" data-id="element-328" />

      <p className="text-gray-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-329">
        "{quote}"
      </p>

      <div className="flex items-center gap-4 mt-auto border-t border-gray-100 pt-6" data-id="element-330">
        <div className="w-12 h-12 rounded-full bg-gray-200 overflow-hidden flex-shrink-0" data-id="element-331">
          {imageUrl ? <img src={imageUrl} alt={author} className="w-full h-full object-cover" data-id="element-332" /> : <div className="w-full h-full bg-[#4B280B] text-white flex items-center justify-center font-bold text-lg" data-id="element-333">
              {author.charAt(0)}
            </div>}
        </div>

        <div data-id="element-334">
          <h4 className="font-bold text-gray-900" data-id="element-335">{author}</h4>
          <p className="text-sm text-gray-500" data-id="element-336">{role}</p>
          <p className="text-sm font-semibold text-[#4B280B] mt-0.5" data-id="element-337">
            {company}
          </p>
        </div>
      </div>
    </div>;
}